import { atcb_action } from 'add-to-calendar-button';
import { useEffect } from 'react';
import eredivisie from '../../assets/icons/eredivisie-large.png';
import kkd from '../../assets/icons/kkd-large.png';
import vrouwenEredivisie from '../../assets/icons/vrouwenEredivisie.png';
import topVisual from '../../assets/images/frontpage-top-2.webp';
import Header from '../../components/blocks/Header';
import PageLayout from '../../layouts/PageLayout';
import { pageView } from '../../scripts/analytics';
import getClubLogo from '../../utils/getClubLogo';
import TabbedContent from './blocks/TabbedContent';

const Calendar = () => {
    const config = {
        subscribe: true,
        options: [
            'Apple',
            'Google',
            'Microsoft365',
            'Outlook.com',
            'Yahoo',
            'iCal',
        ],
        timeZone: 'Europe/Amsterdam',
        startDate: '2023-01-01',
    };

    const tabData = [
        {
            name: 'Eredivisie',
            img: eredivisie,
            content: [
                {
                    name: 'Ajax',
                    img: getClubLogo('Ajax'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Ajax wedstrijden',
                            description:
                                'Volg de wedstrijden van Ajax. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/ajax.ics',
                        });
                    },
                },
                {
                    name: 'Feyenoord',
                    img: getClubLogo('Feyenoord'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Feyenoord wedstrijden',
                            description:
                                'Volg de wedstrijden van Feyenoord. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/feyenoord.ics',
                        });
                    },
                },
                {
                    name: 'PSV',
                    img: getClubLogo('PSV'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'PSV wedstrijden',
                            description:
                                'Volg de wedstrijden van PSV. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/psv.ics',
                        });
                    },
                },
                {
                    name: 'AZ',
                    img: getClubLogo('AZ'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'AZ wedstrijden',
                            description:
                                'Volg de wedstrijden van AZ. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/az.ics',
                        });
                    },
                },
                {
                    name: 'FC Twente',
                    img: getClubLogo('FC Twente'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'FC Twente wedstrijden',
                            description:
                                'Volg de wedstrijden van FC Twente. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/fc-twente.ics',
                        });
                    },
                },
                {
                    name: 'FC Utrecht',
                    img: getClubLogo('FC Utrecht'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'FC Utrecht wedstrijden',
                            description:
                                'Volg de wedstrijden van FC Utrecht. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/fc-utrecht.ics',
                        });
                    },
                },
                {
                    name: 'Fortuna Sittard',
                    img: getClubLogo('Fortuna Sittard'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Fortuna Sittard wedstrijden',
                            description:
                                'Volg de wedstrijden van Fortuna Sittard. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/fortuna-sittard.ics',
                        });
                    },
                },
                {
                    name: 'sc Heerenveen',
                    img: getClubLogo('sc Heerenveen'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'sc Heerenveen wedstrijden',
                            description:
                                'Volg de wedstrijden van sc heerenveen. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/sc-heerenveen.ics',
                        });
                    },
                },
                {
                    name: 'Vitesse',
                    img: getClubLogo('Vitesse'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Vitesse wedstrijden',
                            description:
                                'Volg de wedstrijden van Vitesse. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/vitesse.ics',
                        });
                    },
                },
                {
                    name: 'N.E.C. Nijmegen',
                    img: getClubLogo('N.E.C. Nijmegen'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'N.E.C. Nijmegen wedstrijden',
                            description:
                                'Volg de wedstrijden van N.E.C. Nijmegen. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/nec-nijmegen.ics',
                        });
                    },
                },
                {
                    name: 'Sparta Rotterdam',
                    img: getClubLogo('Sparta Rotterdam'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Sparta Rotterdam wedstrijden',
                            description:
                                'Volg de wedstrijden van Sparta Rotterdam. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/sparta-rotterdam.ics',
                        });
                    },
                },
                {
                    name: 'RKC Waalwijk',
                    img: getClubLogo('RKC Waalwijk'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'RKC Waalwijk wedstrijden',
                            description:
                                'Volg de wedstrijden van RKC Waalwijk. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/rkc-waalwijk.ics',
                        });
                    },
                },
                {
                    name: 'Go Ahead Eagles',
                    img: getClubLogo('Go Ahead Eagles'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Go Ahead Eagles wedstrijden',
                            description:
                                'Volg de wedstrijden van Go Ahead Eagles. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/go-ahead-eagles.ics',
                        });
                    },
                },
                {
                    name: 'Excelsior',
                    img: getClubLogo('Excelsior'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Excelsior wedstrijden',
                            description:
                                'Volg de wedstrijden van Excelsior. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/excelsior.ics',
                        });
                    },
                },
                {
                    name: 'FC Volendam',
                    img: getClubLogo('FC Volendam'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'FC Volendam wedstrijden',
                            description:
                                'Volg de wedstrijden van FC Volendam. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/fc-volendam.ics',
                        });
                    },
                },
                {
                    name: 'Almere City FC',
                    img: getClubLogo('Almere City FC'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Almere City FC wedstrijden',
                            description:
                                'Volg de wedstrijden van Almere City FC. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/almere-city-fc.ics',
                        });
                    },
                },
                {
                    name: 'PEC Zwolle',
                    img: getClubLogo('PEC Zwolle'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'PEC Zwolle wedstrijden',
                            description:
                                'Volg de wedstrijden van PEC Zwolle. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/pec-zwolle.ics',
                        });
                    },
                },
                {
                    name: 'Heracles Almelo',
                    img: getClubLogo('Heracles Almelo'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Heracles Almelo wedstrijden',
                            description:
                                'Volg de wedstrijden van Heracles Almelo. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/heracles-almelo.ics',
                        });
                    },
                },
            ],
        },
        {
            name: 'Keuken Kampioen Divisie',
            img: kkd,
            content: [
                {
                    name: 'FC Groningen',
                    img: getClubLogo('FC Groningen'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'FC Groningen wedstrijden',
                            description:
                                'Volg de wedstrijden van FC Groningen. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/fc-groningen.ics',
                        });
                    },
                },
                {
                    name: 'FC Emmen',
                    img: getClubLogo('FC Emmen'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'FC Emmen wedstrijden',
                            description:
                                'Volg de wedstrijden van FC Emmen. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/fc-emmen.ics',
                        });
                    },
                },
                {
                    name: 'Cambuur Leeuwarden',
                    img: getClubLogo('Cambuur Leeuwarden'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Cambuur Leeuwarden wedstrijden',
                            description:
                                'Volg de wedstrijden van Cambuur Leeuwarden. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/cambuur-leeuwarden.ics',
                        });
                    },
                },
                {
                    name: 'Willem II',
                    img: getClubLogo('Willem II'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Willem II wedstrijden',
                            description:
                                'Volg de wedstrijden van Willem II. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/willem-ii.ics',
                        });
                    },
                },
                {
                    name: 'VVV-Venlo',
                    img: getClubLogo('VVV-Venlo'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'VVV-Venlo wedstrijden',
                            description:
                                'Volg de wedstrijden van VVV-Venlo. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/vvv-venlo.ics',
                        });
                    },
                },
                {
                    name: 'Telstar',
                    img: getClubLogo('Telstar'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Telstar wedstrijden',
                            description:
                                'Volg de wedstrijden van Telstar. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/telstar.ics',
                        });
                    },
                },
                {
                    name: 'TOP Oss',
                    img: getClubLogo('TOP Oss'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'TOP Oss wedstrijden',
                            description:
                                'Volg de wedstrijden van TOP Oss. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/top-oss.ics',
                        });
                    },
                },
                {
                    name: 'Roda JC Kerkrade',
                    img: getClubLogo('Roda JC Kerkrade'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Roda JC Kerkrade wedstrijden',
                            description:
                                'Volg de wedstrijden van Roda JC Kerkrade. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/roda-jc-kerkrade.ics',
                        });
                    },
                },
                {
                    name: 'NAC Breda',
                    img: getClubLogo('NAC Breda'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'NAC Breda wedstrijden',
                            description:
                                'Volg de wedstrijden van NAC Breda. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/nac-breda.ics',
                        });
                    },
                },
                {
                    name: 'MVV Maastricht',
                    img: getClubLogo('MVV Maastricht'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'MVV Maastricht wedstrijden',
                            description:
                                'Volg de wedstrijden van MVV Maastricht. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/mvv-maastricht.ics',
                        });
                    },
                },
                {
                    name: 'Jong PSV',
                    img: getClubLogo('Jong PSV'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Jong PSV wedstrijden',
                            description:
                                'Volg de wedstrijden van Jong PSV. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/jong-psv.ics',
                        });
                    },
                },
                {
                    name: 'Jong FC Utrecht',
                    img: getClubLogo('Jong FC Utrecht'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Jong FC Utrecht wedstrijden',
                            description:
                                'Volg de wedstrijden van Jong FC Utrecht. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/jong-fc-utrecht.ics',
                        });
                    },
                },
                {
                    name: 'Jong Ajax',
                    img: getClubLogo('Ajax'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Jong Ajax wedstrijden',
                            description:
                                'Volg de wedstrijden van Jong Ajax. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/jong-ajax.ics',
                        });
                    },
                },
                {
                    name: 'Jong AZ',
                    img: getClubLogo('AZ'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Jong AZ wedstrijden',
                            description:
                                'Volg de wedstrijden van Jong AZ. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/jong-az.ics',
                        });
                    },
                },
                {
                    name: 'Helmond Sport',
                    img: getClubLogo('Helmond Sport'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Helmond Sport wedstrijden',
                            description:
                                'Volg de wedstrijden van Helmond Sport. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/helmond-sport.ics',
                        });
                    },
                },
                {
                    name: 'FC Eindhoven',
                    img: getClubLogo('FC Eindhoven'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'FC Eindhoven wedstrijden',
                            description:
                                'Volg de wedstrijden van FC Eindhoven. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/fc-eindhoven.ics',
                        });
                    },
                },
                {
                    name: 'FC Dordrecht',
                    img: getClubLogo('FC Dordrecht'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'FC Dordrecht wedstrijden',
                            description:
                                'Volg de wedstrijden van FC Dordrecht. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/fc-dordrecht.ics',
                        });
                    },
                },
                {
                    name: 'FC Den Bosch',
                    img: getClubLogo('FC Den Bosch'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'FC Den Bosch wedstrijden',
                            description:
                                'Volg de wedstrijden van FC Den Bosch. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/fc-den-bosch.ics',
                        });
                    },
                },
                {
                    name: 'De Graafschap',
                    img: getClubLogo('De Graafschap'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'De Graafschap wedstrijden',
                            description:
                                'Volg de wedstrijden van de Graafschaph. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/de-graafschap.ics',
                        });
                    },
                },
                {
                    name: 'ADO Den Haag',
                    img: getClubLogo('ADO Den Haag'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'ADO Den Haag wedstrijden',
                            description:
                                'Volg de wedstrijden van ADO Den Haag. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/ado-den-haag.ics',
                        });
                    },
                },
            ],
        },
        {
            name: 'Vrouwen Eredivisie',
            img: vrouwenEredivisie,
            content: [
                {
                    name: 'sc Heerenveen Vrouwen',
                    img: getClubLogo('sc Heerenveen Vrouwen'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'sc Heerenveen Vrouwen wedstrijden',
                            description:
                                'Volg de wedstrijden van sc Heerenveen Vrouwen. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/sc-heerenveen-vrouwen.ics',
                        });
                    },
                },
                {
                    name: 'Telstar',
                    img: getClubLogo('Telstar'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Telstar Vrouwen wedstrijden',
                            description:
                                'Volg de wedstrijden van Telstar Vrouwen. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/telstar-vrouwen.ics',
                        });
                    },
                },
                {
                    name: 'PSV Vrouwen',
                    img: getClubLogo('PSV'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'PSV Vrouwen wedstrijden',
                            description:
                                'Volg de wedstrijden van PSV Vrouwen. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/psv-vrouwen.ics',
                        });
                    },
                },
                {
                    name: 'PEC Zwolle Vrouwen',
                    img: getClubLogo('PEC Zwolle'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'PEC Zwolle Vrouwen wedstrijden',
                            description:
                                'Volg de wedstrijden van PEC Zwolle Vrouwen. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/pec-zwolle-vrouwen.ics',
                        });
                    },
                },
                {
                    name: 'Fortuna Sittard',
                    img: getClubLogo('Fortuna Sittard'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Fortuna Sittard Vrouwen wedstrijden',
                            description:
                                'Volg de wedstrijden van Fortuna Sittard Vrouwen. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/fortuna-sittard-vrouwen.ics',
                        });
                    },
                },
                {
                    name: 'Feyenoord Rotterdam',
                    img: getClubLogo('Feyenoord'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Feyenoord Rotterdam wedstrijden',
                            description:
                                'Volg de wedstrijden van Feyenoord Rotterdam. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/feyenoord-vrouwen.ics',
                        });
                    },
                },
                {
                    name: 'FC Twente Vrouwen',
                    img: getClubLogo('FC Twente'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'FC Twente Vrouwen wedstrijden',
                            description:
                                'Volg de wedstrijden van FC Twente Vrouwen. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/fc-twente-vrouwen.ics',
                        });
                    },
                },
                {
                    name: 'Excelsior Vrouwen',
                    img: getClubLogo('Excelsior'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Excelsior Vrouwen wedstrijden',
                            description:
                                'Volg de wedstrijden van Excelsior Vrouwen. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/excelsior-vrouwen.ics',
                        });
                    },
                },
                {
                    name: 'VV Alkmaar Vrouwen',
                    img: getClubLogo('VV Alkmaar Vrouwen'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'VV Alkmaar Vrouwen wedstrijden',
                            description:
                                'Volg de wedstrijden van VV Alkmaar Vrouwen. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/vv-alkmaar-vrouwen.ics',
                        });
                    },
                },
                {
                    name: 'Ajax Vrouwen',
                    img: getClubLogo('Ajax Vrouwen'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'Ajax Vrouwen wedstrijden',
                            description:
                                'Volg de wedstrijden van Ajax Vrouwen. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/ajax-vrouwen.ics',
                        });
                    },
                },
                {
                    name: 'ADO Den Haag Vrouwen',
                    img: getClubLogo('ADO Den Haag'),
                    onclick: () => {
                        atcb_action({
                            ...config,
                            name: 'ADO Den Haag Vrouwen wedstrijden',
                            description:
                                'Volg de wedstrijden van ADO Den Haag Vrouwen. Mogelijk gemaakt door https://espn.nl',
                            icsFile:
                                'https://' +
                                window.location.host +
                                '/ics/ado-den-haag-vrouwen.ics',
                        });
                    },
                },
            ],
        },
    ];

    useEffect(() => {
        pageView('kalender');
    }, []);

    return (
        <PageLayout>
            <Header
                image={topVisual}
                title="Voeg de wedstrijden van jouw favoriete club toe aan je kalender!"
                style={{
                    background: `center / cover url(${topVisual}) #00020057`,
                }}
            />
            <div className="container">
                <TabbedContent tabs={tabData} />
            </div>
        </PageLayout>
    );
};

export default Calendar;
